/** @format */

import { propertyMap } from 'model-mapper';
import { File } from '../classes/file';
import { EmbededOrganizationalUnit } from './embeded-organizational-unit';
import { EmbededEquipment } from './equipment';
import { EmbededRealEstateStructure } from './real-estate-structure';
import { UserAnomalyReportNature } from './user-anomaly-report-nature';

export enum UserAnomalyReportFileKind {
  PICTURE = 'picture',
  VIDEO = 'video',
}

export class UserAnomalyReportIntentDocument {
  @propertyMap()
  documentId: string;

  @propertyMap()
  title: string | null;

  @propertyMap()
  filename: string | null;

  @propertyMap()
  owner: string | null;

  @propertyMap()
  createdAt: Date | null;
}

export class UserAnomalyReportProviderNote {
  @propertyMap({ type: Date })
  at: Date | null;

  @propertyMap()
  event: string | null;

  @propertyMap()
  author: string | null;

  @propertyMap()
  note: string;
}

export class UserAnomalyReportIntentSummary {
  @propertyMap({ type: Date })
  createdAt: Date | null;

  @propertyMap({ type: Date })
  requestedAt: Date | null;

  @propertyMap({ type: Date })
  acknowledgedAt: Date | null;

  @propertyMap({ type: Date })
  closedAt: Date | null;

  @propertyMap()
  closedEvent: string | null;

  @propertyMap({ type: UserAnomalyReportIntentDocument })
  interventionReport: UserAnomalyReportIntentDocument | null;

  @propertyMap({ type: [UserAnomalyReportProviderNote] })
  providerNotes: UserAnomalyReportProviderNote[];

  @propertyMap({ type: Date })
  refreshedAt: Date;
}

export class UserAnomalyReportOccurence {
  @propertyMap({ type: Date })
  date: Date;

  @propertyMap()
  userId: string;

  @propertyMap({ type: File })
  picture: File | null;

  @propertyMap({ type: File })
  video: File | null;

  @propertyMap()
  comment: string | null;
}

export class UserAnomalyReport {
  @propertyMap({ type: UserAnomalyReportNature })
  nature: UserAnomalyReportNature;

  @propertyMap({ type: EmbededOrganizationalUnit })
  organizationalUnit: EmbededOrganizationalUnit;

  @propertyMap({ type: EmbededRealEstateStructure })
  realEstateStructure: EmbededRealEstateStructure;

  @propertyMap({ type: EmbededEquipment })
  equipment: EmbededEquipment;

  @propertyMap({ type: UserAnomalyReportOccurence })
  occurences: UserAnomalyReportOccurence;

  @propertyMap({ type: Date })
  createdAt: Date;

  @propertyMap({ type: Date })
  closedAt: Date | null;

  @propertyMap({ type: UserAnomalyReportIntentSummary })
  intentSummary?: UserAnomalyReportIntentSummary;
}
